function formatAddress(address: any, type = 'Ship', sep = '\r\n') {
  return [
    address[`${type}Name`],
    address[`${type}Address1`] || null,
    address[`${type}Address2`] || null,
    address[`${type}Address3`] || null,
    `${address[`${type}City`]
      ? `${address[`${type}City`]},`
      : ''} ${address[`${type}State`] || ''} ${address[`${type}Zip`] || ''}`,
  ].filter(v => !!v).join(sep) || ''
}

function formatDate(date: string | undefined) {
  if (!date)
    return ''

  const dateArr = date.split('T')[0].split('-')
  dateArr.push(dateArr.shift() || '')
  return dateArr.join('/')
}

function formatDateTime(date: string | undefined) {
  if (!date)
    return ''

  const dateArr = (date.split('T')[0] || '').split('-')
  const timeArr = (date.split('T')[1] || '').split(':')
  dateArr.push(dateArr.shift() || '')
  timeArr.pop()
  return `${dateArr.join('/')} ${timeArr.join(':')}`
}
function formatDateTimeUTC(date: string | undefined) {
  if (!date)
    return ''
  const newDate = new Date(date)
  const formatter = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23', // Forces a 24-hour (00-23) clock
  })
  const formattedDate = formatter.format(newDate).replace(',', '')
  return formattedDate.toLocaleString()
}

function formatNumber(val: number, style: any = 'decimal') {
  const formatter = new Intl.NumberFormat('en-US', { style, currency: 'USD' })
  return formatter.format(val)
}

function formatOrderCount(qty: number) {
  return `${qty} Order${qty !== 1
    ? 's'
    : ''}`
}

export function useFormatter() {
  return {
    formatAddress,
    formatDate,
    formatDateTime,
    formatDateTimeUTC,
    formatNumber,
    formatOrderCount,
  }
}
